import { lazy } from 'react';

import {
	extractChunkUrlFromMessage,
	getStaticAssetUrl,
} from 'src/modules/chunk-url';

const CHUNK_REFRESH_TIMEOUT_MS = 1_000;

/**
 * Reescreve a entrada de cache do chunk que falhou. `cache: 'reload'` ignora o
 * cache na ida e grava a resposta nova; `cache: 'no-store'` apenas evitaria o
 * cache daquela requisição e deixaria a entrada anterior intacta.
 */
const refreshFailedChunk = async (error: unknown): Promise<void> => {
	const chunkUrl = extractChunkUrlFromMessage(
		error instanceof Error ? error.message : undefined
	);
	const assetUrl = chunkUrl ? getStaticAssetUrl(chunkUrl) : null;

	if (!assetUrl) return;

	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), CHUNK_REFRESH_TIMEOUT_MS);

	try {
		await fetch(assetUrl.href, {
			cache: 'reload',
			redirect: 'error',
			signal: controller.signal,
		});
	} catch {
		// A recuperação depende da segunda tentativa do import, não desta consulta.
	} finally {
		clearTimeout(timeout);
	}
};

/**
 * `React.lazy` com uma segunda tentativa depois de revalidar o chunk. Se ela
 * também falhar, o erro sobe para a boundary, que faz a recuperação.
 */
export const lazyWithRetry: typeof lazy = factory =>
	lazy(() =>
		factory().catch(async error => {
			await refreshFailedChunk(error);
			return factory();
		})
	);
